<template>
  <div class="applied-allocation" data-testid="applied-allocation">
    <div v-if="hasError" class="applied-allocation__error">
      <BaseText>
        Não foi possível carregar os dados neste momento. Aguarde alguns
        instantes e tente novamente.
      </BaseText>
      <ButtonTertiary
        label="Tentar novamente"
        @click="fetchAppliedAllocation"
      />
    </div>
    <AllocationLoader v-else-if="isLoading" />
    <section v-else-if="appliedAllocation">
      <AppliedChart
        class="applied-allocation__chart"
        :applied-chart="appliedChart"
      />
      <AppliedTable :applied-table="appliedTable" :portfolio-id="portfolioId" />
    </section>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue';

import { BaseText, ButtonTertiary } from '@warrenbrasil/nebraska-web';
import { AppliedChart, AppliedTable } from './components';
import { AllocationLoader } from '@/modules/wealth/components/AllocationLoader';

import {
  getAppliedAllocation,
  IAppliedAllocation
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  portfolioId: string;
}

const { portfolioId } = defineProps<Props>();

const appliedAllocation = ref<IAppliedAllocation>();
const isLoading = ref(true);
const hasError = ref(false);

const appliedChart = computed(() => {
  return appliedAllocation.value!.chart;
});

const appliedTable = computed(() => {
  return appliedAllocation.value!.items;
});

async function fetchAppliedAllocation() {
  hasError.value = false;
  isLoading.value = true;

  try {
    appliedAllocation.value = await getAppliedAllocation(portfolioId);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  fetchAppliedAllocation();
});
</script>

<style lang="less" scoped>
.applied-allocation {
  &__error {
    width: 320px;
    height: 360px;
    margin: auto;
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__chart {
    margin-bottom: @size-spacing-x500;
  }
}
</style>
